var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon is-large",attrs:{"target":"_blank","href":_vm.url}},[_c('fa',{attrs:{"icon":['fab', 'twitter'],"size":"2x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }